import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import './RDPassword.scss';

const { Password } = Input;

const RDPassword = ({ placeholder, inputStyles, onChange, value, disabled, inputLength }) => (
  <Password
    placeholder={placeholder}
    onChange={onChange}
    style={inputStyles}
    value={value}
    disabled={disabled}
    maxLength={inputLength}
  />
);

RDPassword.defaultProps = {
  placeholder: '',
  inputStyles: {},
  value: '',
  onChange: () => {},
  disabled: false,
  inputLength: 100,
};

RDPassword.propTypes = {
  /** The placeholder of the input */
  placeholder: PropTypes.string,
  /** To customize the style of the input box */
  inputStyles: PropTypes.shape({}),
  /** Callback function executed when value is changed */
  onChange: PropTypes.func,
  /** The input content value */
  value: PropTypes.string,
  /** Whether the input is disabled */
  disabled: PropTypes.bool,
  /** The max length allowed in input */
  inputLength: PropTypes.number,
};

export default RDPassword;
